import { Chart as ChartJS } from 'chart.js/auto';

// Set global font
ChartJS.defaults.font.family = "'Khmer OS Battambang', 'Battambang', sans-serif";
